<template>
    <div class="card">
        <div class="table-header mb-3">
            <div style="text-align: left">
                <Button @click="deleteCharacteristics()" icon="pi pi-trash" class="mr-1" label="Очистити історію" />
                <a :href="route('api.configurator-products.excel.export')">
                    <Button icon="pi pi-external-link" label="Скачати в Excel" />
                </a>
            </div>
        </div>
        <DataTable
            :value="data"
            v-model:selection="selectedCharacteristics"
            v-model:filters="filterParams.filters"
            filterDisplay="row"
            paginator
            lazy
            :rows="filterParams.perPage"
            :rowsPerPageOptions="[50, 100, 200]"
            :total-records="total"
            :loading="loading"
            @page="onPage($event)"
            @filter="getData()"
            class="customTable scroll_h"
            @sort="onSort($event)"
            @row-select-all="onSelectAllChange"
            @row-select="onRowSelect"
            @row-unselect="onRowUnselect"
        >
            <Column selectionMode="multiple" :class="{'select-all-selected': selectAll}" headerStyle="width: 1rem"></Column>
            <Column field="type" :sortable="true" header="Конфігуратор" headerStyle="width: 1rem">
                <template #body="slotProps">
                    {{ slotProps.data.type }}
                </template>
                <template #filter>
                    <Dropdown style="width: 100px" v-model="filterParams.filters.type.value" :options="types" @change="getData()" optionLabel="name" optionValue="value" placeholder="Оберіть значення" />
                </template>
            </Column>
            <Column field="catalog_product_id" :sortable="true" header="ID">
                <template #body="slotProps">
                    {{ slotProps.data.catalog_product_id }}
                </template>
            </Column>
            <Column field="name" :sortable="true" header="Найменування товару">
                <template #body="slotProps">
                    {{ slotProps.data.name }}
                </template>
            </Column>
            <Column field="configurator_product_article" :sortable="true" header="Артикул">
                <template #body="slotProps">
                    <a :href="slotProps.data.catalog_product_id ? '/price-list?product=' + slotProps.data.catalog_product_id : '/price-list-internal'" target="_blank">{{ slotProps.data.configurator_product_article }}</a>
                </template>
                <template #filter>
                    <InputText v-model="filterParams.filters.configurator_product_article.value" type="text" @input="getData()" placeholder="Пошук" />
                </template>
            </Column>
            <Column field="message" :sortable="true" header="Інформація">
                <template #body="slotProps">
                    <span :class="{ 'text-danger': slotProps.data.message_type === 1, 'text-info': slotProps.data.message_type === 2 }">{{ slotProps.data.message }}</span>
                </template>
            </Column>
            <Column field="created_at" :sortable="true" header="Дата створення">
                <template #body="slotProps">
                    {{ moment(slotProps.data.created_at).format("DD.MM.YYYY") }}
                </template>
            </Column>
            <Column field="" header="">
                <template #body="slotProps">
                    <a href="#" @click.prevent="() => {selectedCharacteristics=[]; selectedCharacteristics.push(slotProps.data); deleteCharacteristics()}">
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.26671 9.66683L0.333374 8.7335L4.06671 5.00016L0.333374 1.26683L1.26671 0.333496L5.00004 4.06683L8.73337 0.333496L9.66671 1.26683L5.93337 5.00016L9.66671 8.7335L8.73337 9.66683L5.00004 5.9335L1.26671 9.66683Z" fill="#B70D09"/>
                        </svg>
                    </a>
                </template>
            </Column>
        </DataTable>

        <div class="bottom_btns">
            <a href="javascript:void(0)" class="add_file_btn main" v-if="selectedCharacteristics.length" @click="deleteCharacteristics()">Видалити</a>
            <a href="javascript:void(0)" class="add_file_btn main disabled" v-else>Видалити</a>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import AppLayout from "@/Layouts/AppLayout";
import DataTable from "primevue/datatable";
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import swal from 'sweetalert2';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import Toast from 'primevue/toast';
import {FilterMatchMode} from "primevue/api";
import moment from "moment";

export default {

    components: {
        DataTable,
        Column,
        InputText,
        swal,
        Dialog,
        Button,
        Dropdown,
        Toast,
    },
    layout: AppLayout,

    data() {
        return {
            moment: moment,
            data: [],
            total: 0,
            selectedCharacteristics: [],
            filterParams: {
                page: 1,
                perPage: 50,
                order_by: 'created_at',
                order: 1,
                filters: {
                    type: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    configurator_product_article: { value: null, matchMode: FilterMatchMode.CONTAINS },
                }
            },
            loading: false,
            selectAll: false,
            isAddCharacteristics: false,
            types: [
                {
                    value: 'avr',
                    name: 'АВР'
                },
                {
                    value: 'klemnyi_riad',
                    name: 'Клемні ряди'
                },
                {
                    value: 'plavni_pusky',
                    name: 'Плавні пуски'
                },
                {
                    value: 'sho125',
                    name: 'ЩО125'
                },
                {
                    value: 'ya5000',
                    name: 'я5000'
                },
                {
                    value: 'kalkulyator_pidboru_zhorstkoyi_shini',
                    name: 'Калькулятор жорсткої шини'
                },
                {
                    value: 'kalkulyator_pidboru_gnuchkoy_shini',
                    name: 'Калькулятор гнучкої шини'
                },
            ],
        }
    },

    mounted() {
        this.getData();
    },

    methods: {
        onSort(event) {
            this.filterParams.order_by = event.sortField
            this.filterParams.order = event.sortOrder
            
            this.getData()
        },
        getData() {
            this.loading = true
            axios.post(this.route('api.configurator-products.get'), this.filterParams).then(result => {
                this.data = result.data.products.data;
                this.total = result.data.products.total;
                this.loading = false
            });
        },
        deleteCharacteristics() {
            new swal({
                title: 'Ви впевнені?',
                text: 'Обрані елементи будуть видалені',
                icon: 'warning',
                showConfirmButton: true,
                showCancelButton: true,
                buttons: ['Скасувати', 'Підтвердити'],
            }).then((result) => {
                if (!result.isConfirmed) {
                    this.selectedCharacteristics = []
                    return
                }

                axios.post(this.route('api.configurator-products.delete'), {data: this.selectedCharacteristics})
                    .then((result) => {
                        this.getData()
                        this.selectedCharacteristics = []
                        this.$toast.add({ severity: 'success', summary: 'Успішно видалено!', detail: 'Елементи успішно видалено', life: 3000 });
                    }).catch((error) => {
                        this.selectedCharacteristics = []
                        alert(error);
                        window.scroll(0, 0);
                    })

            });
        },
        onPage(event) {
            this.filterParams.page = event.page+1
            this.filterParams.perPage = event.rows
            this.getData()
        },
        onSelectAllChange() {
            if (this.data.length >= this.filterParams.perPage) {
                if (!this.selectAll) {
                    this.selectAll = true;
                    this.selectedCharacteristics = this.data
                } else {
                    this.selectAll = false;
                    this.selectedCharacteristics = [];
                }
            }
        },
        onRowSelect() {
            if (this.data.length >= this.filterParams.perPage) {
                this.selectAll = this.selectedCharacteristics.length === this.data.length
            }
        },
        onRowUnselect() {
            if (this.data.length >= this.filterParams.perPage) {
                this.selectAll = false;
            }
        },
    }
};
</script>

<style scoped>
.bottom_btns {
    display: flex;
    gap: 16px;
    padding-top: 50px;
}
.add_file_btn {
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    border-radius: 4px;
    background: #356EEF;
    display: flex;
    width: 237px;
    height: 40px;
    padding: 8px 16px;
    justify-content: center;
    align-items: center;
    text-decoration: none!important;
}
.add_file_btn.disabled {
    cursor:not-allowed;
    filter: opacity(0.5);
}
.add_file_btn.main {
    background-color: #FFFFFF;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
    color: #000000;
    box-shadow: 0px 1px 2px 0px #0000004D;
}
.confirm_buttons {
    display: flex;
    gap: 20px;
}
.confirm_button_cancel {
    display: flex;
    padding: 12px 30px;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    background: #356EEF;
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 100%;
}
.confirm_button_confirm {
    display: flex;
    padding: 12px 30px;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    background: #FFF;
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 100%;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.30);
}
.price_input {
    height: 40px!important;
    width: 100%;
    align-items: center;
    display: flex;
}
.check-text input {
  display: none;
}
.check-text svg {
  cursor: pointer;
}
.modal_main_content_container {
    display: flex;
    flex-direction: column;
    gap: 20px;
}
.p-inputtext {
    height: auto;
}
.p-dropdown-label .p-inputtext{
    align-items: center;
    display: flex;
}

.scroll_h {
    overflow: auto;
}

.text-info {
    color: #ffc107;
}
.text-danger {
    color: #dc3545;
}
</style>
